<ng-container *ngIf="!isAcmic && (pifEligible || isPaidInFull)">

  <ng-container *ngIf="isPaidInFull; else notPaidInFull">
    <div [class]="variant === 'bn-overview' ? 'bn-title-text' : 'policy-info-row'">
      <div class="dash-check-img-row">
        <img src="assets/img/images/check-circle-new.svg" alt="payment convenience icon" />
        <span class="label-col">Paid in full discount</span>
      </div>
    </div>
  </ng-container>

  <ng-template #notPaidInFull>

    <!-- BN-Overview variant -->
    <ng-container *ngIf="variant === 'bn-overview'; else policyCardLayout">
      <div>
        <div class="bn-title-text mb-2">
          <div class="d-flex" (click)="isMobile && toggleTooltip($event, pifTooltip)">
            <div>Pay in full and save**</div>
            <div class="ml-1">
              <app-info-tooltip *ngIf="pifTooltipContent"
                #pifTooltip
                [content]="pifTooltipContent"
                [align]="'left'"
                [position]="'bottom'"
              ></app-info-tooltip>
            </div>
          </div>
        </div>
        <div class="dflex-align-center gap-8">
          <div class="bn-title-val">{{ pifDiscountInfo.pifDiscountedPremium?.theAmount | currency }}</div>
          <ng-container *ngIf="hasPriorPif; else noPriorPif">
            <div class="supporting-text">
              non discount {{ pifDiscountInfo.nonDiscountedPremium?.theAmount | currency }}
            </div>
          </ng-container>
          <ng-template #noPriorPif>
            <span class="pif-save-amount">save {{ savingsAmount | currency }}</span>
            <span class="ml-2 pif-best-value-pill">Best value</span>
          </ng-template>
        </div>
      </div>
    </ng-container>

    <!-- Policy Card variant -->
    <ng-template #policyCardLayout>
      <div class="policy-info-row">
        <span class="label-col">
          <div class="d-flex align-items-center">
            <div (click)="isMobile && toggleTooltip($event, pifTooltip)">Pay in full and save**</div>
            <div class="ml-1">
              <app-info-tooltip *ngIf="pifTooltipContent"
                #pifTooltip
                [content]="pifTooltipContent"
                [align]="'left'"
                [position]="'bottom'"
              ></app-info-tooltip>
            </div>
          </div>
        </span>
        <span class="content-col d-flex align-items-center flex-wrap gap-8 nowrap">
          <span class="highlight">
            {{ pifDiscountInfo.pifDiscountedPremium?.theAmount | currency }}
          </span>
          <ng-container *ngIf="hasPriorPif; else noPriorPif">
            <div class="supporting-text">
              non discount {{ pifDiscountInfo.nonDiscountedPremium?.theAmount | currency }}
            </div>
          </ng-container>
          <ng-template #noPriorPif>
            <span class="pif-save-amount">save {{ savingsAmount | currency }}</span>
            <span class="pif-best-value-pill">Best value</span>
          </ng-template>
        </span>
      </div>
    </ng-template>

  </ng-template>

</ng-container>
